import React, { useState } from "react";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { useAdminAuth } from "../context/AdminAuthContext";

export default function AdminLogin() {
    const { login } = useAdminAuth();
    const [pwd, setPwd] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await login(pwd);
            toast.success("Welcome back");
        } catch (err) {
            toast.error("Wrong password");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="pt-32 pb-20" data-testid="admin-login-page">
            <div className="mx-auto max-w-md px-6">
                <div className="p-8 rounded-sm bg-bg1 border border-white/10">
                    <div className="flex justify-center mb-5">
                        <div className="w-14 h-14 rounded-full bg-lime/15 text-lime flex items-center justify-center">
                            <Lock className="w-6 h-6" />
                        </div>
                    </div>
                    <h1 className="font-display text-3xl uppercase tracking-tight text-center">Admin Access</h1>
                    <p className="text-zinc-500 text-sm text-center mt-2">Enter your admin password to continue.</p>
                    <form onSubmit={submit} className="mt-6 space-y-4">
                        <input
                            type="password"
                            value={pwd}
                            onChange={(e) => setPwd(e.target.value)}
                            placeholder="Password"
                            autoFocus
                            data-testid="admin-login-password"
                            className="w-full bg-bg0 border border-white/10 rounded-sm px-4 py-3 focus:border-lime outline-none placeholder:text-zinc-600"
                        />
                        <button
                            type="submit"
                            disabled={submitting}
                            data-testid="admin-login-submit"
                            className="btn-pill btn-primary w-full disabled:opacity-50"
                        >
                            {submitting ? "Signing in…" : "Sign In"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
